<script lang="ts" setup>
import { MainMenu } from './useMainMenu'

withDefaults(
  defineProps<{
    menu: MainMenu
    activeId?: string | null
    onClick?: (id: string) => void
  }>(),
  {
    activeId: null,
    onClick: () => {},
  },
)
</script>
<template>
  <ul :class="['menu', { 'is-expanded': activeId }]">
    <li v-for="item in menu" :key="item.id" class="menu-item">
      <NuxtLink
        :class="['link', 'f-bold', 'f-24', { 'is-active': item.isActive }, { 'is-expanded': item.id === activeId }]"
        :to="item.url"
        @click="onClick(item.id)"
      >
        {{ item.title }}
        <Icon v-if="item.items?.length" name="link-arrow" />
      </NuxtLink>
    </li>
  </ul>
</template>
<style lang="scss" scoped>
.menu {
  display: flex;
  flex-direction: column;
  gap: 14px;

  margin-top: 96px;

  @include breakpoint(tl) {
    max-width: 50%;
  }
}

.link {
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 2px 0;

  color: var(--c-primary);
  svg {
    --size: 16px;
    width: var(--size);
    height: var(--size);
  }
}
</style>
